





import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AttendanceChart from "./components/AttendanceChart";
import LeaveWidget from "./components/LeaveTable";
import UserAttendance from "../attendance/UserAttendance";
import UserTasks from "../attendance/UserTasks";
import CreateFeed from "../../pages/posts/CreateFeed";
import CreatePostModal from "../../pages/posts/CreatePostModal";
import MonthlyTaskAccuracy from "./components/MonthlyTaskAccuracy";
 
 
 
 
export default function Dashboard() {
 
  const [showPostModal, setShowPostModal] = useState(false);
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.state?.tab || "attendance");
 
  useEffect(() => {
    if (location.state?.tab) {
      setActiveTab(location.state.tab);
      setTimeout(() => {
        const tabEl = document.getElementById("dashboard-tabs");
        if (tabEl) {
          // Adjust scroll position slightly higher so tabs are clearly visible
          const y = tabEl.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 300);
    }
  }, [location.state]);
 
  const user = JSON.parse(localStorage.getItem("user"));
  const roleId = Number(user?.role_id);
  const isHR = roleId === 2;
 


  useEffect(() => {
    if (location.state?.scrollTo === "auto") {
      setTimeout(() => {
        const user = JSON.parse(localStorage.getItem("user"));
        const roleId = Number(user?.role_id);
        const isHR = roleId === 2;
  
        const targetId = isHR ? "attendance-chart" : "user-tasks";
  
        const el = document.getElementById(targetId);
  
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
    }
  }, [location.state]);
  return (
    <div className="p-1">
      <div className="md:mt-24 mt-14">
 
        {/* ================= TOP ATTENDANCE CHART (UNCHANGED) ================= */}
        {isHR && (
          // <div>
          <div id="attendance-chart">
            <AttendanceChart />
          </div>
        )}
 
{!isHR && (
          <>
            {/* LEFT SIDE - TASKS */}
            {/* <div className="xl:col-span-8"> */}
            <div id="user-tasks" className="xl:col-span-8">
              <UserTasks />
            </div>
 
            {/* RIGHT SIDE - ATTENDANCE */}
              {/* <div className="xl:col-span-4 ">
                <UserAttendance />
              </div> */}
          </>
        )}
 
        {/* ================= TABS ================= */}
        <div id="dashboard-tabs" className="flex gap-4 mt-8 mb-[-10px] p-2 overflow-x-auto no-scrollbar ">
 
          <button
            onClick={() => setActiveTab("attendance")}
            className={`px-5 py-2   rounded-xl font-semibold ${
              activeTab === "attendance"
                ? "bg-[#12082F] text-white shadow-md md:shadow-lg rounded-[40px] border border-white/10"
                : "bg-[#c0cbe5] text-gray-600 shadow-md md:shadow-lg rounded-[40px]"
            }`}
          >
            Attendance
          </button>
 
          <button
            onClick={() => setActiveTab("posts")}
            className={`px-5 py-2 rounded-xl font-semibold ${
              activeTab === "posts"
              ? "bg-[#12082F] text-white shadow-md md:shadow-lg rounded-[40px] border border-white/10"
              : "bg-[#c0cbe5] text-gray-600 shadow-md  md:shadow-lg rounded-[40px]"
            }`}
          >
            Posts
          </button>

          {/* {isHR && (
            <button
              onClick={() => setActiveTab("monthly-tasks")}
              className={`px-5 py-2 rounded-xl font-semibold whitespace-nowrap ${
                activeTab === "monthly-tasks"
                  ? "bg-[#12082F] text-white shadow-md md:shadow-lg rounded-[40px] border border-white/10"
                  : "bg-[#c0cbe5] text-gray-600 shadow-md md:shadow-lg rounded-[40px]"
              }`}
            >
              Monthly Tasks
            </button>
          )} */}

          <button
            onClick={() => setActiveTab("leaderboard")}
            className={`px-5 py-2 rounded-xl font-semibold whitespace-nowrap ${
              activeTab === "leaderboard"
                ? "bg-[#12082F] text-white shadow-md md:shadow-lg rounded-[40px] border border-white/10"
                : "bg-[#c0cbe5] text-gray-600 shadow-md md:shadow-lg rounded-[40px]"
            }`}
          >
            Leaderboard
          </button>
 
 
          <button
   onClick={() => setShowPostModal(true)}
  className="bg-[#c0cbe5] text-gray-600 shadow-md md:shadow-lg whitespace-nowrap rounded-[40px]  px-6 py-2 rounded-xl font-semibold hover:bg-[#362A60] hover:text-white hover:shadow-lg flex justify-end"
  >
  + Create Post
</button>
 
        </div>
 
        {/* ================= TAB CONTENT ================= */}
 
        {/* Attendance tab */}
        {activeTab === "attendance" && (
          <>
            {isHR && (
              <LeaveWidget />
            )}
 
{!isHR && (
          <>
            {/* LEFT SIDE - TASKS */}
     
 
            {/* RIGHT SIDE - ATTENDANCE */}
            <div className="xl:col-span-4 md:mt-10 ">
              <UserAttendance />
            </div>
          </>
        )}
          </>
        )}
 
{/* Monthly Tasks tab (HR only) */}
{activeTab === "monthly-tasks" && isHR && (
  <div className="mt-2">
    <MonthlyTaskAccuracy defaultView="tasks" />
  </div>
)}

{/* Leaderboard tab */}
{activeTab === "leaderboard" && (
  <div className="mt-2">
    <MonthlyTaskAccuracy defaultView="leaderboard" />
  </div>
)}

{/* Posts tab */}
{activeTab === "posts" &&  (
  <div className="mt-6">
    <CreateFeed
 
    />
  </div>
)}
 
{/* GLOBAL CREATE POST MODAL */}
 
<CreatePostModal
  showModal={showPostModal}
  setShowModal={setShowPostModal}
/>
      </div>
    </div>
  );
}




// import { useState } from "react";
// import AttendanceChart from "./components/AttendanceChart";
// import LeaveWidget from "./components/LeaveTable";
// import UserAttendance from "../attendance/UserAttendance";
// import UserTasks from "../attendance/UserTasks";
// import CreateFeed from "../../pages/posts/CreateFeed";
// import CreatePostModal from "../../pages/posts/CreatePostModal";




// export default function Dashboard() {

//   const [showPostModal, setShowPostModal] = useState(false);
//   const [activeTab, setActiveTab] = useState("attendance");

//   const user = JSON.parse(localStorage.getItem("user"));
//   const roleId = Number(user?.role_id);
//   const isHR = roleId === 2;

//   return (
//     <div className="p-1">
//       <div className="md:mt-24 mt-14">

//         {/* ================= TOP ATTENDANCE CHART (UNCHANGED) ================= */}
//         {isHR && (
//           <div>
//             <AttendanceChart />
//           </div>
//         )}

// {!isHR && (
//           <>
//             {/* LEFT SIDE - TASKS */}
//             <div className="xl:col-span-8">
//               <UserTasks />
//             </div>

//             {/* RIGHT SIDE - ATTENDANCE */}
//               {/* <div className="xl:col-span-4 ">
//                 <UserAttendance />
//               </div> */}
//           </>
//         )}

//         {/* ================= TABS ================= */}
//         <div className="flex gap-4 mt-8 mb-[-10px] overflow-x-auto no-scrollbar ">

//           <button
//             onClick={() => setActiveTab("attendance")}
//             className={`px-5 py-2   rounded-xl font-semibold ${
//               activeTab === "attendance"
//                 ? "bg-[#362A60] text-white shadow-md md:shadow-lg rounded-[40px]"
//                 : "bg-[#c0cbe5] text-gray-600 shadow-md md:shadow-lg rounded-[40px]"
//             }`}
//           >
//             Attendance
//           </button>

//           <button
//             onClick={() => setActiveTab("posts")}
//             className={`px-5 py-2 rounded-xl font-semibold ${
//               activeTab === "posts"
//               ? "bg-[#362A60] text-white shadow-md md:shadow-lg rounded-[40px]"
//               : "bg-[#c0cbe5] text-gray-600 shadow-md  md:shadow-lg rounded-[40px]"
//             }`}
//           >
//             Posts
//           </button>


//           <button
//    onClick={() => setShowPostModal(true)}
//   className="bg-[#c0cbe5] text-gray-600 shadow-md md:shadow-lg whitespace-nowrap rounded-[40px]  px-6 py-2 rounded-xl font-semibold hover:bg-[#362A60] hover:text-white hover:shadow-lg flex justify-end"
//   >
//   + Create Post
// </button>

//         </div>

//         {/* ================= TAB CONTENT ================= */}

//         {/* Attendance tab */}
//         {activeTab === "attendance" && (
//           <>
//             {isHR && (
//               <LeaveWidget />
//             )}

// {!isHR && (
//           <>
//             {/* LEFT SIDE - TASKS */}
      

//             {/* RIGHT SIDE - ATTENDANCE */}
//             <div className="xl:col-span-4 md:mt-10 ">
//               <UserAttendance />
//             </div>
//           </>
//         )}
//           </>
//         )}

// {/* Posts tab */}
// {activeTab === "posts" &&  (
//   <div className="mt-6">
//     <CreateFeed 
  
//     />
//   </div>
// )}

// {/* GLOBAL CREATE POST MODAL */}

// <CreatePostModal
//   showModal={showPostModal}
//   setShowModal={setShowPostModal}
// />
//       </div>
//     </div>
//   );
// }

// import AttendanceChart from "./components/AttendanceChart";
// import LeaveWidget from "./components/LeaveTable";
// import UserAttendance from "../attendance/UserAttendance";
// import UserTasks from "../attendance/UserTasks";   
// import CreateFeed from "../../pages/posts/CreateFeed"; 
// export default function Dashboard() {

//   const user = JSON.parse(localStorage.getItem("user"));
//   const roleId = Number(user?.role_id);
//   const isHR = roleId === 2;

//   return (
//     <div className="p-1">
//       <div className="md:mt-24 mt-14 ">
//         {/* ================= HR DASHBOARD ================= */}
//         {isHR && (
//           <>
//             <div className="">
//               <AttendanceChart />
//             </div>
//           </>
          
//         )}
//         {isHR && (
//  <div className="xl:col-span-4">
//               <LeaveWidget />
//             </div>
//                )}
//         {/* ================= EMPLOYEE DASHBOARD ================= */}
        // {!isHR && (
        //   <>
        //     {/* LEFT SIDE - TASKS */}
        //     <div className="xl:col-span-8">
        //       <UserTasks />
        //     </div>

        //     {/* RIGHT SIDE - ATTENDANCE */}
        //     <div className="xl:col-span-4 ">
        //       <UserAttendance />
        //     </div>
        //   </>
        // )}

//             {/* ================= FEEDS BELOW ATTENDANCE ================= */}
//             <div className="mt-6">
//               <CreateFeed />
//             </div>

//       </div>
//     </div>
//   );
// }

